import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import Button from "@/components/button.vue"
  import ContentModal from "@/components/modals/content.vue"
  import ContactDetailsEditor from  "@/components/editors/contact_details.vue"
  import ContactDetailsList from  "@/components/lists/contact_details.vue"
  import {Supplier as SupplierClient} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {onBeforeMount, ref} from "vue"
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import PurchaseOrderEditor from "@/components/editors/purchase_order.vue"
  import OrderList from "@/components/lists/order.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'supplier',
  props: {
    supplierID: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const error = ref<Error>(null)
  const supplierClient = new SupplierClient()
  const supplier = ref<Supplier>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const selectedOrderIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      supplier.value = await supplierClient.summary(props.supplierID)
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (supplier.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("h1", null, " Supplier ", -1)),
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", null, " Name ", -1)),
                _createElementVNode("td", null, _toDisplayString(supplier.value.name), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("th", null, " Memorandum ", -1)),
                _createElementVNode("td", null, _toDisplayString(supplier.value.memorandum), 1)
              ])
            ])
          ]),
          (supplier.value.contactDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[8] || (_cache[8] = _createElementVNode("h2", null, " Contact Details ", -1)),
                _createVNode(ContactDetailsList, {
                  selectedIndex: selectedContactDetailsIndex.value,
                  "onUpdate:selectedIndex": _cache[0] || (_cache[0] = ($event: any) => ((selectedContactDetailsIndex).value = $event)),
                  items: supplier.value.contactDetails.records,
                  readOnly: ""
                }, null, 8, ["selectedIndex", "items"]),
                (selectedContactDetailsIndex.value != null)
                  ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(ContactDetailsEditor, {
                          value: supplier.value.contactDetails.records[selectedContactDetailsIndex.value],
                          readOnly: ""
                        }, null, 8, ["value"]),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createVNode(Button, {
                          title: "Close",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedContactDetailsIndex.value = null))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (supplier.value.orders && supplier.value.orders.records)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[10] || (_cache[10] = _createElementVNode("h2", null, " Orders ", -1)),
                _createVNode(OrderList, {
                  selectedIndex: selectedOrderIndex.value,
                  "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedOrderIndex).value = $event)),
                  items: supplier.value.orders.records
                }, null, 8, ["selectedIndex", "items"]),
                (selectedOrderIndex.value != null)
                  ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(PurchaseOrderEditor, {
                          value: supplier.value.orders.records[selectedOrderIndex.value],
                          readOnly: ""
                        }, null, 8, ["value"]),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        _createVNode(Button, {
                          title: "Close",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedOrderIndex.value = null))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 2,
                error: error.value,
                "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})